@if (isAutocompleteDisplayed) {
  <div class="autocomplete-list custom-menu custom-menu-panel" (document:click)="outsideClickHandler($event)">
    <div #customMenuContent class="custom-menu-content" [style.maxHeight]="calculatedMaxMenuHeight">
      <perfect-scrollbar>
        @for (suggestion of matchedSuggestions; track i; let i = $index) {
          <div
            class="autocomplete-item custom-menu-item"
            [id]="'option' + i"
            [class.focus]="i === focusedSuggestionIndex"
            (click)="selectSuggestion(suggestion)"
          >
            <span>
              {{ suggestion }}
            </span>
          </div>
        }
      </perfect-scrollbar>
    </div>
  </div>
}
